import { render, staticRenderFns } from "./AlertsSection.vue?vue&type=template&id=58ad42ed&scoped=true&"
import script from "./AlertsSection.vue?vue&type=script&lang=js&"
export * from "./AlertsSection.vue?vue&type=script&lang=js&"
import style0 from "./AlertsSection.vue?vue&type=style&index=0&id=58ad42ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad42ed",
  null
  
)

export default component.exports